export const formName = 'copyWagonJourneyForm';
